<template>
  <ExternalList
      headline="Portals"
      endpoint="/api/v2/portal-companies"
      :endpoint-filters="{company_id: company.data.id}"
      :headlines="headlines"
      :checkbox-column-width="2"
      :button-column-width="2"
      :can-show="() => true"
      :can-destroy="() => false"
      :show-checkboxes="false"
      :show-buttons="false"
      :show-list-actions="false"
      :show-pagination="false"
      :default-page-size="100"
      @show="portalCompany => $router.push('/companies/' + company.data.id + '/portals/' + portalCompany.id)"
  >
    <template v-slot:default="{ row: portalCompany }">
      <td>
        <router-link :to="'/companies/' + company.data.id + '/portals/' + portalCompany.id">
          {{ portalCompany.attributes.portal_name }}
        </router-link>
      </td>

      <td>
        <Avatar v-if="portalCompany.attributes.user_id" :color="portalCompany.attributes.user_color">
          {{ portalCompany.attributes.user_initials }}
        </Avatar>
      </td>
    </template>
  </ExternalList>
</template>

<script>
import ExternalList from '../../../../../../../components/Panels/Lists/External'
import moment from 'moment'
import Avatar from "../../../../../../../components/Avatar.vue";

export default {
  components: {Avatar, ExternalList},

  props: {
    company: {
      required: true
    }
  },

  computed: {
    headlines() {
      return [
        {width: 12, text: 'Portal'},
        {width: 12, text: 'User'},
      ]
    }
  }
}
</script>
